import { render } from "./Dashboard2.vue?vue&type=template&id=40b8fe12&scoped=true"
import script from "./Dashboard2.vue?vue&type=script&lang=js"
export * from "./Dashboard2.vue?vue&type=script&lang=js"

import "./Dashboard2.vue?vue&type=style&index=0&id=40b8fe12&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b8fe12"]])

export default __exports__